import React from 'react';
import { Link } from 'react-router-dom';

function AdminArticles({ articles }) {
  return (
    <section className="admin-panel">
      <div className="admin-panel-head">
        <div>
          <span className="admin-overline">CONTENT</span>
          <h2>Published articles</h2>
          <p>Stories currently available on the publication.</p>
        </div>
        <b>{articles.length} total</b>
      </div>

      <div className="admin-table-wrap">
        <table>
          <thead>
            <tr>
              <th>Headline</th>
              <th>Category</th>
              <th>Type</th>
              <th>Source</th>
              <th>Published</th>
              <th>Views</th>
            </tr>
          </thead>
          <tbody>
            {articles.map((article) => (
              <tr key={article.id}>
                <td>
                  <Link to={`/article/${article.slug}`}>
                    <b>{article.title}</b>
                  </Link>
                </td>
                <td>{article.category}</td>
                <td>{article.label}</td>
                <td>{article.source}</td>
                <td>{article.date}</td>
                <td>{article.views}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {!articles.length && (
        <p className="admin-empty">
          No published articles were found in Supabase.
        </p>
      )}
    </section>
  );
}

export default AdminArticles;